/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 新建/编辑页
 */
'use strict';
angular.module("activityModule", [
	'activityRouterModule',
	'activityCalendarModule',
	'activityCalendarServiceModule'
]).
controller('activityCtrl', ['$scope', '$state', 'localStorageService', '$validation', '$timeout', "ueditorService", '$filter', 'modalDialog', '$stateParams', '$element', '$compile', '$q', 'httpService', 'editPictureService', function($scope, $state, localStorageService, $validation, $timeout, ueditorService, $filter, modalDialog, $stateParams, $element, $compile, $q, httpService, editPictureService) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			show: true,
			borderColor: "#39B88C", //自定义时间下拉框hover边框颜色
			hide: true,
			startEndTime: "",
			calendarTime: [
				[]
			], //日历时间
			isBackstage: false, //区分后台和前台
		};
		$scope.data = {};
		$scope.list = {
			id: 0,
			articleTitle: "",
			articleContent: "",
			articleHtmlCon: "",
			/*coverType: 0,
			coverImg: [],*/
			activityPrice: '0',
			activityRemark: "",
			activityAddr: "",
			activityTimeMode: 0,
			activityTime: "",
			articleStatus: ""
		};
	}
	/**
	 * [setCost description] 选中收费之后校验错误，重新点击收费后移除校验错误提示
	 */
	$scope.setCost = function() {
		$element.find('.activityPrice .tips').remove();
	};
	/**
	 * [cancelCalendar description] 取消日历
	 * @return {[type]} [description]
	 */
	$scope.cancelCalendar = function() {
		$scope.list.activityTimeMode = 0;
	};

	function initData() {
		getPubWayInfo().then(function() {
			initCover();
			return initList();
		}).then(function() {
			loadUeditor();
		});
		getPicSizeLimit();
	}
	/**
	 * [uploadPic description] 上传渠道封面图片
	 * @return {[type]} [description]
	 */
	$scope.uploadPic = function($files, $file, $newFiles, item, attribute) {
		if(!$file) return;
		uploadPic($file).then(function(res) {
			editPictureService.newCropperAppForImage(angular.globalConfig.pictureServer + res.url, $scope.status.channels[0].channelPicSize).then(function(data) {
				if(data.success == '上传成功') {
					item[attribute] = angular.globalConfig.pictureServer + data.imgSrc;
				} else {
					modalDialog.success("图片上传失败", "error", false, function() {});
				}
			}, function(res) {

			});

		})
	};
	/**
	 * [uploadPic description] 上传图片的公共方法
	 * @return {[type]} [description]
	 */
	function uploadPic(file) {
		var defer = $q.defer();
		if(file.size > Number($scope.status.picSizeLimit) * 1024) {
			modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
			return;
		}
		var fd = new FormData();
		var name = file.name;
		fd.append("file", file);
		fd.append("name", name);
		$.ajax({
			url: '/mcnww/upload/image.do',
			type: 'POST',
			headers:{requestToken:sessionStorage.getItem('requestToken')},
			async: false,
			data: fd,
			processData: false,
			contentType: false,
			success: function(responseStr) {
				defer.resolve(responseStr);
			}
		});
		return defer.promise;
	}

	/**
	 * [save description] 保存
	 * @return {[type]} [description]
	 */
	$scope.save = function(bPub) {
		$scope.list.bPub = bPub;
		saveContent().then(function() {
			return validator();
		}).then(function() {
			var timeFlag = packageStartEndTime();
			if(!timeFlag) return;
			var flag = packageClassify();
			if(!flag) return;
			return save();
		}).then(function(data) {
			if(data&&data.success) {
				var newId = data.id;
				$scope.list.id = newId;
				reFreshListPage();
				ueditorService.saveToLocal(newId);
				modalDialog.success((bPub ? "投稿" : "保存稿件") + "成功", "success", false, function() {
					if(bPub) {
						window.close();
					}
					$state.go("activity", {
						id: newId,
						type: 5
					}, {
						reload: "activity"
					});
				}, function() {}, '', 'left0');
			}
		});

	};
	/**
	 * [save description] 保存请求
	 * @return {[type]} [description]
	 */
	function save() {
		var deffer = $q.defer();
		$scope.list.articleWordsCount = $scope.list.DOCWORDSCOUNT;
		$scope.list.id = $scope.list.id === 0 ? "" : $scope.list.id;
		httpService.http("/mcnww/web/pgcArticle/saveActiveArticle.do", $scope.list, "post").then(function(data) {
			deffer.resolve(data);
		});

		return deffer.promise;
	}
	/**
	 * [packageStartEndTime description] 打包起始时间
	 * @return {[type]} [description]
	 */
	function packageStartEndTime() {
		if($scope.list.activityTimeMode === 0) {
			var obj = {
				date: [$scope.status.startDate, $scope.status.endDate],
				time: $scope.status.startEndTime
			};
			$scope.list.activityTime = JSON.stringify(obj);
			return true;
		} else {
			$scope.list.activityTime = JSON.stringify($scope.status.calendarTime);
			if($scope.status.calendarTime[0].length === 0) {
				modalDialog.alertType("您还没有在日历上设置活动时间", "", "warning", "confirm");
				return false;
			}
			return true;
		}
	}
	/**
	 * [packageClassify description] 打包分类数据
	 * @return {[type]} [description]
	 */
	function packageClassify() {
		var channels = [];
		for(var i in $scope.status.channels) {
			var channel = $scope.status.channels[i];
			if(channel.checked){
				if(!channel.selectedItem){
					modalDialog.alertType('渠道【'+channel.channelName+'】下没有配置一级标签，不能保存稿件', "", "warning", "confirm");
					return false;
				}else if(!channel.selectedItem.selectedItem){
					modalDialog.alertType('渠道【'+channel.channelName+'】下没有配置二级标签，不能保存稿件', "", "warning", "confirm");
					return false;
				}else if(channel.selectedItem&&channel.selectedItem.selectedItem) {
					var channel_ = {
						channelId: channel.id,
						channelName: channel.channelName,
						firstTagId: channel.selectedItem.id,
						secondTagId: channel.selectedItem.selectedItem.id,
						coverType: channel.coverType
					};
					if(channel.coverType === 0) {
						channel_.coverImg = JSON.stringify([channel.pic1]);
					} else {
						channel_.coverImg = JSON.stringify([channel.pic1, channel.pic2, channel.pic3]);
					}
					channels.push(channel_);
				}
			}
		}
		$scope.list.channels = JSON.stringify(channels);
		var flag = channels.length > 0;
		if(!flag) {
			modalDialog.alertType("请至少选择一个发布渠道", "", "warning", "confirm");
			var html = $("html");
			var div = $(".qudao")[0];
	      	html.animate({ scrollTop: html.scrollTop() + $(div).offset().top - html.offset().top }, 1000);
		}
		return flag;
	}
	/**
	 * [validator description] 表单校验
	 * @return {[type]} [description]
	 */
	function validator() {
		var deffer = $q.defer();
		$validation.validate($scope.activityForm).success(function() {
			deffer.resolve();
		}).error(function(result) {
			angular.invalidPosition($scope.activityForm, $element);
		});
		return deffer.promise;
	}
	/**
	 * [saveContent description] 保存正文
	 * @return {[type]} [description]
	 */
	function saveContent() {
		var deffer = $q.defer();
		ueditorService.saveContent($scope.list);
		if($scope.list.articleHtmlCon === "") {
			$timeout(function() {
				//表单校验手动触发
				$scope.activityForm.content.$error.content = true;
				$scope.activityForm.content.$valid = false;
				$scope.activityForm.content.$invalid = true;
				$scope.activityForm.$error.content = [$scope.activityForm.content];
				$scope.activityForm.$valid = false;
				$scope.activityForm.$invalid = true;
				deffer.resolve();
			});
		} else {
			deffer.resolve();
		}
		return deffer.promise;
	}
	/**
	 * [getPicSizeLimit description] 获取图片尺寸上限
	 * @return {[type]} [description]
	 */
	function getPicSizeLimit() {
		httpService.http("/mcnww/web/image/getImageSizelimit.do", "", "get").then(function(data) {
			$scope.status.picSizeLimit = data.message;
		});
	}
	/**
	 * [initList description] 初始化表单数据
	 * @return {[type]} [description]
	 */
	function initList() {
		var deffer = $q.defer();
		if(!!$stateParams.id) {
			$scope.status.hide = false;
			getDraftInfo().then(function(result) {
				for(var i in $scope.list) {
					$scope.list[i] = result.articeInfo[i];
				}
				/*if ($scope.list.activityPrice != 0) {
				    $scope.list.activityPrice = Number($scope.list.activityPrice);
				}*/
				deffer.resolve();
				initActiveTime();
				initClassify(result.chnlsAndTags);
			});
		} else {
			deffer.resolve();
		}
		return deffer.promise;
		/**
		 * [initActiveTime description] 初始化活动时间
		 * @return {[type]} [description]
		 */
		function initActiveTime() {
			if($scope.list.activityTimeMode === 0) {
				var activityTime = JSON.parse($scope.list.activityTime);
				$scope.status.startDate = activityTime.date[0];
				$scope.status.endDate = activityTime.date[1];
				$scope.status.startEndTime = [activityTime.time[0], activityTime.time[1]];
			} else {
				$scope.status.calendarTime = JSON.parse($scope.list.activityTime);
			}
		}
		/**
		 * [initClassify description] 初始化分类
		 * @return {[type]} [description]
		 */
		function initClassify(chnlsAndTags) {
			for(var i in $scope.status.channels) {
				var channel = $scope.status.channels[i];
				for(var j in chnlsAndTags) {
					var chnlAndTag = chnlsAndTags[j];
					if(channel.id === chnlAndTag.pubChannelId) {
						//处理图片开始
						channel.coverType = chnlAndTag.coverType;
						var imgArray = JSON.parse(chnlAndTag.coverImg);
						channel.pic1 = imgArray[0];
						if(chnlAndTag.coverType === 1) {
							channel.pic2 = imgArray[1];
							channel.pic3 = imgArray[2];
						}
						//处理图片结束
						channel.checked = true;
						for(var k in channel.tags) {
							var tag = channel.tags[k];
							if(tag.id === chnlAndTag.firstTagId) {
								channel.selectedItem = tag;
								for(var l in tag.children) {
									var tag_ = tag.children[l];
									if(tag_.id === chnlAndTag.secondTagId) {
										channel.selectedItem.selectedItem = tag_;
									}
								}
							}
						}
					}
				}
			}
		}
	}
	/**
	 * [initCover description]  初始化封面
	 * @return {[type]} [description]
	 */
	function initCover() {
		for(var i in $scope.status.channels) {
			var channel = $scope.status.channels[i];
			channel.coverType = 0;
		}
	}
	/**
	 * [getDraftInfo description] 查询稿件信息
	 * @return {[type]} [description]
	 */
	function getDraftInfo() {
		var deffer = $q.defer();
		var params = {
			articleId: $stateParams.id
		};
		httpService.http("/mcnww/web/pgcArticle/findById.do", params, "get").then(function(result) {
			deffer.resolve(result);
		});
		return deffer.promise;
	}
	/**
	 * [loadUeditor description] 加载编辑器
	 * @return {[type]} [description]
	 */
	function loadUeditor() {
		var $ueditor = $("<ueditor></ueditor>");
		var $ueditorLocation = $element.find("ueditorLocation");
		LazyLoad.js(["./static/ueditor/ueditor.config.js?v=11.4", "./static/ueditor/ueditor.all.js?v=11.4"], function() {
			$ueditor.attr({
				"has-content": "status.hasContent",
				list: "list",
				versionid: $scope.list.id ? $scope.list.id : 0,
				infullscreen: "status.infullscreen",
				placeholder: "请输入文章正文"
			});
			$ueditor = $compile($ueditor)($scope);
			$ueditorLocation.append($ueditor);
		});
	}
	/**
	 * [getPubWay description] 获取发布渠道相关信息
	 * @return {[type]} [description]
	 */
	function getPubWayInfo() {
		var deffer = $q.defer();
		httpService.http("/mcnww/web/channel/querySignChnlsAndTags.do", "", "get").then(function(data) {
			$scope.status.channels = data.channels;
			data.tags = (function() {
				var array = [];
				for(var k in data.tags) {
					array.push(data.tags[k]);
				}
				return array;
			})();
			attributeName(data.tags);
			for(var i = 0; i < $scope.status.channels.length; i++) {
				for(var j = 0; j < data.tags.length; j++) {
					if(data.tags[j].length!==0&&data.tags[j][0].channelId === $scope.status.channels[i].id) {
						$scope.status.channels[i].tags = data.tags[j];
						$scope.status.channels[i].selectedItem = $scope.status.channels[i].tags[0];
						if($scope.status.channels[i].selectedItem.children&&$scope.status.channels[i].selectedItem.children.length>1){
							$scope.status.channels[i].selectedItem.selectedItem = $scope.status.channels[i].selectedItem.children[0];
						}
					}
				}
			}
			deffer.resolve();
		});

		function attributeName(array) {
			for(var i = 0; i < array.length; i++) {
				var array_ = array[i];
				for(var j = 0; j < array_.length; j++) {
					array_[j].name = array_[j].tagName;
					var array__ = array_[j].children;
					if(array__ != null) {
						for(var k = 0; k < array__.length; k++) {
							array__[k].name = array__[k].tagName;
						}
					}

				}
			}
		}
		return deffer.promise;
	}
	$scope.delete = function(id, val) {
		var cs = $scope.status.channels;
		cs.forEach(function(item) {
			if(item.id == id) {
				switch(val) {
					case 1:
						item.pic1 = null;
						break;
					case 2:
						item.pic2 = null;
						break;
					case 3:
						item.pic3 = null;
						break;
				}
			}
		})
	}
	/**
	 * [reFreshList description] 刷新列表页
	 * @return {[type]} [description]
	 */
	function reFreshListPage() {
		localStorageService.set("refresh", Math.random());
	}
}]);